import React, { useEffect, useState, useMemo } from 'react';
import { Container, Row, Col, Spinner } from 'react-bootstrap';
import ProductsChart from './charts/ProductsChart';
import RomaneiosChart from './charts/RomaneiosChart';
import TransfersChart from './charts/TransfersChart';
import { getCharts } from '../../services/Charts/chartsService';
import { usePermissions } from '../../hooks/usePermissions';
import { usePermissionsContext } from '../../context/PermissionsContext';

const Dashboard = () => {
  const { ToastComponent, hasPermission } = usePermissions();
  const { permissions } = usePermissionsContext();
  const [chartsData, setChartsData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Recalcula permissões sempre que o objeto permissions mudar
  const canView = useMemo(() => hasPermission('chartsView'), [hasPermission, permissions]);

  useEffect(() => {
    const fetchCharts = async () => {
      if (!canView) {
        setLoading(false);
        return;
      }
      try {
        const data = await getCharts();
        if (data && typeof data === 'object') {
          setChartsData(data);
        } else {
          setError('Dados inválidos recebidos do servidor');
        }
      } catch (err) {
        setError(err?.message || 'Erro ao carregar os gráficos');
      } finally {
        setLoading(false);
      }
    };

    fetchCharts();
  }, [canView]);

  if (!canView) {
    return (
      <>
        <ToastComponent />
        <Container fluid className="dashboard-container">
          <h3 className="mb-4 mt-2 text-center text-md-start">Dashboard</h3>
        </Container>
      </>
    );
  }

  if (loading) {
    return (
      <Container fluid className="dashboard-container text-center">
        <Spinner animation="border" role="status">
          <span className="visually-hidden">Carregando...</span>
        </Spinner>
      </Container>
    );
  }

  if (error) {
    return (
      <Container fluid className="dashboard-container text-center">
        <p className="text-danger">Erro ao carregar os gráficos: {error}</p>
      </Container>
    );
  }

  if (!chartsData || !chartsData.romaneios || !chartsData.transfers || !chartsData.products) {
    return (
      <Container fluid className="dashboard-container text-center">
        <p>Carregando dados dos gráficos...</p>
      </Container>
    );
  }

  return (
    <Container fluid className="dashboard-container">
      <ToastComponent />
      <h3 className="mb-4 mt-2 text-center text-md-start">Dashboard</h3>
      <Row className='mt-3'>
        <Col md={6}>
          <RomaneiosChart data={chartsData.romaneios?.detail} />
        </Col>
        <Col md={6}>
          <TransfersChart data={chartsData.transfers?.detail} />
        </Col>
      </Row>
      <Row className='mt-3'>
        <Col md={12}>
          <ProductsChart data={chartsData.products?.detail} />
        </Col>
      </Row>
    </Container>
  );
};

export default Dashboard;